import React from 'react';

const AddressSection = () => {
  return (
    <div className="space-y-4 pt-4 m-[2%]">
      <div className="rounded-lg border bg-white shadow-sm">
        <div className="p-6 border-b">
          <h2 className="text-xl font-semibold">Endereços</h2>
          <p className="text-sm text-gray-500">Gerencie seus endereços de entrega</p>
        </div>
        
        <div className="p-6 space-y-6">
          {/* Grid de Endereços */}
          <div className="grid gap-4 md:grid-cols-2">
            {/* Cartão de Endereço - Casa */}
            <div className="rounded-lg border bg-white shadow-sm">
              <div className="p-4 border-b">
                <div className="flex items-center justify-between">
                  <h3 className="text-base font-medium">Casa</h3>
                  <div className="flex items-center gap-2">
                    <button className="h-8 px-2 text-sm font-medium text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-md">
                      Editar
                    </button>
                    <button className="h-8 px-2 text-sm font-medium text-red-600 hover:text-red-900 hover:bg-red-50 rounded-md">
                      Remover
                    </button>
                  </div>
                </div>
                <p className="text-sm text-gray-500">Principal</p>
              </div>
              <div className="p-4 space-y-1">
                <p className="text-sm">João da Silva</p>
                <p className="text-sm">Rua das Flores, 123</p>
                <p className="text-sm">Jardim Primavera</p>
                <p className="text-sm">São Paulo - SP</p>
                <p className="text-sm">CEP: 01234-567</p>
                <p className="text-sm">Tel: (11) 98765-4321</p>
              </div>
            </div>

            {/* Cartão de Endereço - Trabalho */}
            <div className="rounded-lg border bg-white shadow-sm">
              <div className="p-4 border-b">
                <div className="flex items-center justify-between">
                  <h3 className="text-base font-medium">Trabalho</h3>
                  <div className="flex items-center gap-2">
                    <button className="h-8 px-2 text-sm font-medium text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-md">
                      Editar
                    </button>
                    <button className="h-8 px-2 text-sm font-medium text-red-600 hover:text-red-900 hover:bg-red-50 rounded-md">
                      Remover
                    </button>
                  </div>
                </div>
              </div>
              <div className="p-4 space-y-1">
                <p className="text-sm">João da Silva</p>
                <p className="text-sm">Av. Paulista, 1000</p>
                <p className="text-sm">Bela Vista</p>
                <p className="text-sm">São Paulo - SP</p>
                <p className="text-sm">CEP: 01310-100</p>
                <p className="text-sm">Tel: (11) 3456-7890</p>
              </div>
            </div>
          </div>

          {/* Botão Adicionar */}
          <div className="flex justify-end">
            <button className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors">
              Adicionar Novo Endereço
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddressSection;